

const Searchbar = () => {
    return(
        <div className="flex items-center relative justify-end md:justify-center md:static flex-grow w-full">

            <input type="checkbox" id = 'nav_searchbox_check' className="hidden"/>

            <div className="relative left-[-10px] md:left-0 grow md:grow-0 md:static border-[1px] border-[#BFBFBF] hidden md:flex rounded-[8px] bg-[#FAFAFA] dark:bg-dark-nav-bg" id = 'nav_searchbox'>
                <button className="flex items-center justify-center px-4 ">
                    <svg className="w-6 h-6 text-gray-600 dark:text-white" fill="currentColor" xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24">
                        <path
                            d="M16.32 14.9l5.39 5.4a1 1 0 0 1-1.42 1.4l-5.38-5.38a8 8 0 1 1 1.41-1.41zM10 16a6 6 0 1 0 0-12 6 6 0 0 0 0 12z" />
                    </svg>
                </button>
                <input type="text" className="px-2 py-2 bg-transparent navbar_search_input w-full md:w-[500px] lg:w-[30vw] xl-w-[500px] md:max-w-[40vw]" placeholder="Search Collections"></input>
            </div>

            <label for = 'nav_searchbox_check' className="2px nav_search_toggle lg:hidden w-[25px] h-[25px] mb-[8px] dark:text-white" id = 'nav_search_close'>
                <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 352 512">
                    <path d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"/>
                </svg>
            </label> 

            <label for = 'nav_searchbox_check' className="2px nav_search_toggle md:hidden w-[25px] h-[25px] dark:text-white" id = 'nav_search_open' >
                <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 512 512">
                    <path d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"/>
                </svg>
            </label> 

        </div>
    )
}

export default Searchbar;